const React = require('react');
const {openPopupWindow} = require('../../../../../emitters/popup');
const Popup = require('../../../../dumb/Popup/C');
const {apiAdminForcePwdReset} = require("../../../../../api/admin/retailers");
const {FormFooterAgreement, FormWrapper} = require("../../../../dumb/FormHandlers");

module.exports = (data, update) => openPopupWindow((setPopupState, popup) => {
  const {close} = popup;

  const resultModalData = [
    'Password reset completed',
    `After next login user will be asked to change password.`
  ];

  const onSubmit = () => (
    apiAdminForcePwdReset({merchant_id: data.id})
  );

  const onResult = () => {
    update();
    close();
  }

  return () => {
    return (
      <Popup
        caption={(
          <div className="layoutRow fhaS fvaC w">
            <div>Password Reset</div>
          </div>
        )}
      >
        <div className="mt20">Do you want to reset password of {data.login}?</div>
        <FormWrapper
          onSubmit={onSubmit}
          resultModalData={resultModalData}
          onResult={onResult}
        >{(formCtx) => (
          <FormFooterAgreement
            submitBtnData={{
              text: 'Proceed',
              formCtx
            }}
            additionalBtnsList={[
              {
                text: 'Cancel',
                onClick: close
              }
            ]}
          />
        )}</FormWrapper>
      </Popup>
    );
  };
});
